/*
 * sourced from EE version of glad.com
 *   orig checked in to track all changes
 */

var CLWP_PC_GLOBAL = CLWP_PC_GLOBAL || {};

(function ($) {
    'use strict';

    if (window['GLAD_GLOBAL']) {
        var $win = $(window);
        GLAD_GLOBAL.useMobileUI = function () {
            // determine which UI mode to use
            return $win.width() < 769;
        };
    }

    // cache var
    var $win = $(window);
    var $body = $('body');
    var $doc = $(document);

    // handle orientationchange
    // close & reopen tiles
    $win.on('orientationchange', function () {
        //console.log('orientationchange: '+window.orientation);
        var $close = $('.close-button:visible');
        if ($close.length) {
            $close.click();
            History.back();
        }
    });

    /**
     * @module quizManager
     * purpose: Manages the quiz
     *
     * @author Luc Martin @ Clorox
     * @version 1.1
     */
    var quizManager = (function () {
        // closure to maintain the state of affairs
        var quizBrain = {
            allQuiz: {},
        };

        /**
         * @method initListeners
         * purpose initialize the Listeners for a quiz
         *
         * @author Luc Martin at clorox
         * @version 1.0
         */
        function privateInitListeners() {
            /**
             * Listener for the quiz answer click
             */
            $body.on('click touchstart', '.quiz-answer', function () {
                // handle click
                handleQuizAnswerClick(this);
            });

            /**
             *  Listener for the cycle-2 slide change event
             * Purpose: Will handle the quiz solves when the slide with all solves is being display
             */
            $body.on('cycle-before', function (e, options, currSlideElement, nextSlideElement) {
                //console.log($(nextSlideElement))
                $('.hidden-by-tip').show().removeClass('hidden-by-tip');
                $('.show-tip').addClass('hidden').removeClass('show-tip');
                // test if we have a solve slide
                var $nextSlide = $(nextSlideElement);
                var solve = $nextSlide.find('.solve-wrapper');
                if ($(solve).length > 0) {
                    //console.log('fund a solve')
                    // we do process the solve
                    solveQuiz(nextSlideElement);
                    $('.quiz-img').addClass('hidden');
                }
            });

            /**
             * Listener for the cycle-2 post init event
             * Purpose: adds handler for custom next button
             *      replaces normal next button to verify quiz question
             *      has been answered
             */
            $body.on('cycle-post-initialize', function (e, opts) {
                $('.carousel-control.next-custom').on('click', function () {
                    // check curr slide for quiz answers
                    /* next-custom button only appears after quiz answered
                var $slide = $(opts.slides[opts.currSlide]);
                var $answers = $slide.find('.quiz-answer');
                if ($answers.length && !$answers.hasClass('selected')) {
                    //console.log('user must select answer');
                    return false;
                }
                */
                    opts.API.next();
                });
                $('.carousel-control.next-custom').on('keydown', function (e) {
                    if (e.keyCode == 13 || e.keyCode == 32) {
                        e.preventDefault();
                        opts.API.next();
                    }
                });

                $('.carousel-control.previous').on('keydown', function (e) {
                    if (e.keyCode == 13 || e.keyCode == 32) {
                        e.preventDefault();
                        opts.API.prev();
                    }
                });
            });

            // override advanceSlide & jump fns to prevent advancing
            //   on quizzes until answered
            $body.on('cycle-bootstrap', function (e, optionHash, API) {
                var origAdvanceSlide = API.advanceSlide;
                var opts = optionHash;
                API.advanceSlide = function (n) {
                    var $slide = $(opts.slides[opts.currSlide]);
                    var $answers = $slide.find('.quiz-answer');
                    if (n < 0 || !$answers.length || $answers.hasClass('selected')) {
                        origAdvanceSlide.call(API, n);
                    }
                };

                var origJump = API.jump;
                API.jump = function (n) {
                    var $slide = $(opts.slides[opts.currSlide]);
                    var $answers = $slide.find('.quiz-answer');
                    if (n < opts.currSlide || !$answers.length || $answers.hasClass('selected')) {
                        origJump.call(API, n);
                    }
                };
            });

            // disable/enable next button on quizzes until answer selected
            $doc.on('slide.change', function (e, slideid, $nextSlide) {
                //console.log('slide.change',$nextSlide)
                var $answers = $nextSlide.find('.quiz-answer');
                if ($answers.length && !$answers.hasClass('selected')) {
                    // disable next button until item selected
                    $('.carousel-control.next-custom').addClass('disabled');
                }
            });
            $body.on('quiz-answer.selected', function () {
                $('.carousel-control.next-custom').removeClass('disabled');
            });

            // resize carousel height for each slide - dynamic resizing
            $doc.on('slide.change', function (e, slideid, $nextSlide, init) {
                var $carousel = $nextSlide.closest('.carousel');
                var $pager = $carousel.find('.cycle-pager');
                // wait for resizing of initial slide
                var fixHeight = function () {
                    // fix for quiz result slides height

                    if ($nextSlide.find('.solve-wrapper').length) {
                        var wrapperHeight = $nextSlide.find('.solve-wrapper').height();
                        var $bodyRight = $nextSlide.find('.body-right');
                        $bodyRight.css('height', wrapperHeight);
                        $bodyRight.css('min-height', wrapperHeight);
                    }

                    var slideHeight = $nextSlide.height();
                    if (slideHeight < 100) {
                        // wait for a valid height
                        setTimeout(fixHeight, 500);
                        return;
                    }

                    var height = slideHeight + $pager.height();
                    $carousel.height(height);
                    $carousel.css('min-height', height);
                };
                setTimeout(fixHeight, 250 + init ? 1000 : 0);
            });
        }

        /**
         * @method privateFormatList
         * purpose: formats the list html for stuff that needs to be calculated after
         *
         * @author Luc Martin at Clorox.com
         * @version 1.0
         */
        function privateFormatList() {
            var quiz = $('.quiz-with-result,.quiz-with-result-no-tip');
            var slide = $('.slide');
            $(quiz).each(function () {
                var countTotal = $('.quiz-question', this).length;
                //console.log('Count total '+countTotal);
                var count = 1;
                $(this)
                    .find('.slide')
                    .each(function () {
                        $('.top-right', this).prepend(
                            '<span><strong>' +
                                count +
                                ' </strong></span>' +
                                '<span>of</span> <span><strong> ' +
                                countTotal +
                                '</strong></span>'
                        );
                        count = ++count;
                    });
            });
        }

        /**
         * @method handleQuizAnswerClick
         * Purpose: handles when a user answer a quiz question
         *
         * @params target Object: the event target
         * @author Luc Martin at clorox
         * @version 1.0
         *
         */
        function handleQuizAnswerClick(target) {
            // makes the a click on an answer the div act like radio buttons

            // removes the class selected from all siblings
            $(target).siblings().removeClass('selected');

            // add class selected to the answer
            $(target).addClass('selected');

            $body.trigger('quiz-answer.selected');

            // show the tip
            showTip(target);
        }

        /**
         * @method showTip
         * Purpose: show the tip
         *
         * @params target Object: the event target
         * @author Luc Martin at clorox
         * @version 1.0
         *
         */
        function showTip(target) {
            // up one level in th html hierarchy
            var $parent = $(target).parent();
            var slide = $parent.closest('.slide');

            // find the tip related to that answer
            var $tip = $('.quiz-answer-tip', $parent);

            if (
                typeof $(target).attr('data-hide-on-tip') !== 'undefined' &&
                $(target).attr('data-hide-on-tip') == '1'
            ) {
                $('.quiz-answer', $parent).hide().addClass('hidden-by-tip');
                $('.top-right', slide).hide().addClass('hidden-by-tip');
            }
            // show the tip
            $tip.removeClass('hidden').addClass('show-tip');
        }

        /**
         *
         * @method countSelected
         * Purpose: counts all the selected answers
         * find the score for each of them
         * cleanup the Brain from old memories of precedent counts
         * compile scores in the brain
         *
         * @params target Object: the event target (the slide with quiz solve)
         * @author Luc Martin at clorox
         * @version 1.0
         *
         */
        function countSelected(target) {
            // up in the html hierarchy to the parent div
            var $parent = $(target).closest('.quiz-with-result,.quiz-with-result-no-tip');

            // sub brain to check if memory is cleared of old scores
            var dataIsCleared = {};

            // get the quiz id
            var quizId = $('.solve-wrapper', target).attr('data-quizid');

            // v2 has overall score
            quizBrain.allQuiz[quizId].score = 0;

            // iterate through all quiz slides
            $('.quiz-answer.selected', $parent).each(function () {
                // the quiz being evaluated

                // Is the data already cleared? this is in case the user is rolling back n his answers and changes them.
                if (typeof dataIsCleared[quizId] == 'undefined') {
                    // the brain needs to forget about all answers since we are recalculating them
                    for (var n in quizBrain.allQuiz[quizId].items) {
                        // clean up the brain from scores
                        var answerObj = quizBrain.allQuiz[quizId].items[n];
                        answerObj.score = 0;
                    }

                    // set the sub brain id as cleared
                    dataIsCleared[quizId] = 'cleared';
                }

                // now we process the data
                //var questionId = $(this).attr('data-question');
                var answerId = $(this).attr('data-answer');

                var quizType = quizBrain.allQuiz[quizId].type;

                switch (quizType) {
                    case 'v2':
                        // just check against correct answer
                        if (quizBrain.allQuiz[quizId].goal.indexOf(answerId) !== -1) {
                            // count if correct
                            quizBrain.allQuiz[quizId].score++;
                        }
                        break;

                    case 'v1': // original quiz type
                        // evaluate the score for the question
                        for (var n in quizBrain.allQuiz[quizId].items) {
                            // the answer in the brain
                            var answerObj = quizBrain.allQuiz[quizId].items[n];

                            // all values for that solve
                            var scoringChart = answerObj.scoringChart;
                            if (!scoringChart) {
                                continue;
                            }
                            // create a Regex to compare with the scoring chart
                            var regex = new RegExp(answerId);

                            // match the answer to the chart
                            var match = scoringChart.search(regex);

                            // there is a match!
                            if (match > -1) {
                                // add to the score
                                answerObj.score = ++answerObj.score;
                            }
                        }
                        break;
                }
            });
        }
        /**
         * @method privateProcessQuizSolve
         * Purpose: Explodes a <ul> into multiple divs,
         * hides the divs,
         * setup an object in the brain
         * the object will hold the solve, the chart of answers for a solve
         * the score
         * for further quiz management
         * @author Luc Martin @ clorox
         * @version ID
         */
        function privateProcessQuizSolveList(quiz) {
            // extract the answers in the solve ul
            var $quizElements = $('.solve-wrapper ul', quiz);

            // the actual quiz
            var quizId = $('.solve-wrapper', quiz).attr('data-quizid');

            // v1 is the original scoring method
            // new v2 simply scores correct answers
            // new v3 picks a random result
            var quizV2 = $quizElements.data('quiz-v2');
            var quizV3 = $quizElements.data('quiz-v3');

            // init the brain with the new id
            quizBrain.allQuiz[quizId] = {
                //type: quizV2  ? 'v2' : 'v1',
                type: 'v1',
                goal: quizV2,
                items: [],
            };
            if (quizV2) {
                quizBrain.allQuiz[quizId].type = 'v2';
            } else if (quizV3) {
                quizBrain.allQuiz[quizId].type = 'v3';
            }

            var iterator = 0;

            // Iterate through all the quiz elements
            $('li', $quizElements).each(function () {
                var $this = $(this);

                var image = $('img', this).attr('src');
                $('img', this).remove();

                // extract the html data
                var element = $this.html();

                // split (per convention we are using ++ as separator)
                var elementAr = element.split('++');

                // the scoring chart is the second element of the split
                var scoringChart = elementAr[1];

                // the text content
                var content = elementAr[0];

                // set an id to the element (not sure why I did that Dhuuu)
                $this.attr('id', String(quizId) + '-' + String(iterator));

                // stuff the Brain with the information
                quizBrain.allQuiz[quizId].items[iterator] = {
                    scoringChart: scoringChart,
                    text: content,
                    image: image,
                    score: 0,
                    // add str to be used for share url (optional - currently used for wif quiz)
                    share: $this.data('share'),
                };

                iterator = ++iterator;
            });
        }

        /**
         * @method solveQuiz(elem)
         * purpose calculates the results of a quiz, show the solve
         *
         * @param elem Object (generated by the cycle2 event propagation)
         * @author Luc Martin at Clorox
         * @version 1.0
         */
        function solveQuiz(elem) {
            // up in the html hierarchy to the parent div
            //var $parent = $(elem).closest('.quiz-with-result,.quiz-with-result-no-tip');

            //hundredWaysManager.stampGameItem($parent);
            //var gameTag = $parent.attr('data-u');

            //console.log('THE GAME QUIZ HAS A TAG '+gameTag);

            // we are at the last slide, so we need to count all the answers
            countSelected(elem);

            // grab the quiz id from the first element
            var quizId = $(elem).find('.solve-wrapper').first().attr('data-quizid');

            // grab the data in the brain
            var actualQuiz = quizBrain.allQuiz[quizId];

            // winner object
            var winner = {};

            // find solution based on type of quiz
            switch (actualQuiz.type) {
                case 'v3': // random pick
                    winner = actualQuiz.items[Math.floor(Math.random() * actualQuiz.items.length)];
                    break;

                case 'v2': // based on # of correct answers
                    winner = actualQuiz.items[actualQuiz.score];
                    break;

                case 'v1': // original quiz type
                    // top score init
                    var topScore = 0;

                    // iterate through the brain data for that quiz
                    for (var n in actualQuiz.items) {
                        // each question has data
                        var questionData = actualQuiz.items[n];

                        // the score
                        var score = questionData.score;

                        // grab the top score
                        //TODO if we have the same score should we have 2 solves?
                        if (score > topScore) {
                            // WINNER!!!
                            winner = questionData;
                            topScore = score;
                        }
                    }
                    break;
            }

            // we have a winner, report it to satellite
            $body.trigger('satelliteEvent', { type: 'solve', data: winner.text ? winner.text : actualQuiz.type });

            // prep the solve text
            var solve = winner.text;
            var solveImage = winner.image;
            // stuff the text in the last slide
            $(elem)
                .find('.solved')
                .first()
                .html('<div class="solveText">' + solve + '</div>');
            $(elem)
                .find('.solved')
                .first()
                .prepend('<img src="' + solveImage + '" class="solvedImage">');
            $body.trigger('quiz-solved', $(elem).find('.solved').first());

            // update share buttons
            if (winner.share) {
                // text only applies to WIF quiz results - will need to store text in cms to support multiple
                /*
            var $result = $(winner.text.trim());
            var name = $result.find('strong').text();
            name += (name.length ? ' ' : '') + $result.find('em').text();
            name = name.toUpperCase();
            var title = "I'M A " + name + '. ' +
                'Take this simple quiz to see how you and your family manage your waste and get recommendations on how you can waste even less.';
            var templateTwitter = "I'M A " + name + '. ' +
                'Take the quiz and get recommendations on how you can waste even less. {{url}}';
             */
                // post_init();
            }

            //TODO should we communicate the data to someone?
            //$body.trigger('completed-quiz',{'type':'quiz', 'task-id':quizId, u:gameTag});

            // hide the previous button
            $('.carousel-control.previous:visible').hide();
        }

        return {
            processQuizSolveList: function (quiz) {
                privateProcessQuizSolveList(quiz);
            },
            getQuizBrain: quizBrain,
            initListeners: function () {
                privateInitListeners();
            },
            formatList: function () {
                privateFormatList();
            },
        };
    })();

    //******************************************************************************************************************** HUNDRED WAYS MANAGER

    /**
     *@method hundredWaysManager
     * The main object for the 100-ways page
     *
     * @author Luc Martin
     * @version $ID
     */
    var hundredWaysManager = (function () {
        /*
         * maintain state for user
         */
        var hundredWaysManagerBrain = {
            loved: [],
        };
        var pos;
        var nonuser;

        /**
         * @method privateInitFirstState
         * Purpose: Setup the page using the user cookies
         * and the logged in information if any
         * Note: this is in fact a listener but I rather isolate it here because in also is the initial page setup
         *
         * @version 1.0
         * @author Luc Martin at Clorox
         */
        function privateInitFirstState() {
            // cleans the product description from the extra divs
            $('.description').each(function () {
                $('p', this).addClass('hidden');
                $(this).find('p').first().removeClass('hidden');
            });
        }

        /**
         * @method privateInitListeners
         * Purpose Initialize all listeners for the 100 ways page
         *
         * @author Luc Martin
         * @version 1.0
         */
        function privateInitListeners() {
            /**
             * Item click will expand the hidden content
             */
            $body.on('click', '.js-item-tile', function (e, flag) {
                handleItemClick(this, flag);
            });

            $body.on('click', '.share-the-love', function (e) {
                e.stopPropagation();
                //console.log('preventing share the love from triggering the expanded state')
            });

            /**
             * @Listener window scroll
             *
             * Purpose detects window scroll
             * @author Luc Martin
             * @version 1.0
             */
            $win.on('scroll', function () {
                handleWindowScroll(this);
            });

            // tile detail handlers
            /**
             * closes the expanded content
             */
            $body.on('click', '.close-button', function (e, flag) {
                handleCloseButtonClick(e, this, flag);
            });

            $body.on('keydown', '.close-button', function (e, flag) {
                if (e.keyCode == 13 || e.keyCode == 32) {
                    handleCloseButtonClick(e, this, flag);
                }
            });

            /**
             * Listen to the red CTA designers have added to the video hidden content
             * triggers the .video
             */
            $body.on('click', '.video-cta', function (e) {
                e.preventDefault();
                var $this = $(this);
                if ($this.hasClass('disabled')) {
                    return false;
                }
                var parent = $this.closest('.content-main');
                $('.video', parent).trigger('click');

                // disable button once used
                $this.addClass('disabled');
                $this.removeClass('game-action');
                return false;
            });

            $body.on('click', '.love', function (event) {
                handleLoveClick(this);
                event.preventDefault();
                return false;
            });
        }

        /**
         * @method handleLoveClick(this)
         * Purpose: Handle a love this item clic
         * creates cookie for the love items
         *
         * @author Luc Martin at Clorox.com
         * @version 1.0
         */
        function handleLoveClick(caller) {
            var $caller = $(caller);
            var urlTitle = $caller.attr('data-urltitle');

            var index = $.inArray(urlTitle, hundredWaysManagerBrain.loved);
            if ($caller.hasClass('loved')) {
                $caller.removeClass('loved').addClass('game-action');
                hundredWaysManagerBrain.loved.splice(index, 1);
            } else {
                $caller.addClass('loved').removeClass('game-action');
                if (index === -1) {
                    hundredWaysManagerBrain.loved.push(urlTitle);
                }
            }

            $win.trigger('100-ways-state-change');
        }

        /**
         * @method handleCloseButtonClick
         * Purpose: handler for the close button located in the modal dialogs
         *
         * @param e the event object
         * @param target the div where the close button has beeen trigerred
         */
        function handleCloseButtonClick(e, target, flag) {
            // if dlg:
            // $('#dlg .modal').modal('hide')
            var $dlg = $('#dlg .modal');
            if ($dlg.length > 0) {
                popupManager.hidePopup($dlg);
                $dlg.html('');
            } else {
                var $toHide = $('.row.item-detail');
                if (!$toHide.length) {
                    return;
                }
                $toHide.animate(
                    {
                        height: 0,
                    },
                    1000,
                    function () {
                        //$toHide.html('');
                        $toHide.remove();
                    }
                );

                // scroll back to show tile in row above detail
                if (e) {
                    var $tile = $toHide.prev('.js-item-tile');
                    var pos = $tile.position().top;
                    $('html,body').animate(
                        {
                            scrollTop: pos,
                        },
                        500
                    );
                }
            }

            // call item.open with no param for closed
            if (flag !== 'nonuser') {
                $doc.trigger('item.open');
            } else {
                $doc.trigger('item.open.nonuser');
            }
        }

        /**
         * @method closePopup
         * purpose closes the popup dhuuu
         */
        function closePopup() {
            //$('.popup-showing').removeClass('popup-showing').addClass('hidden')
            var $dlg = $('.modal.in');
            if ($dlg.data('bs.modal') && $dlg.data('bs.modal').isShown) {
                popupManager.hidePopup($dlg);
            }
        }

        /**
         * @method showPopup
         * Purpose: show a popup
         *
         * @author Luc Martin
         * @version 1.0
         */
        function showPopup(name, controls) {
            //console.log('showPopup: '+name);

            // show/hide soccer welcome (registration-pre) based on url
            if (History.getState().hash.indexOf('entertainment-will-it-fit-soccer') !== -1) {
                $('.soccer-welcome').removeClass('hidden');
            } else {
                $('.soccer-welcome').addClass('hidden');
            }

            $('.control-showing').addClass('hidden').removeClass('control-showing');
            if (controls) {
                for (var n = 0; n < controls.length; ++n) {
                    var control = controls[n];
                    $(control, name).removeClass('hidden').addClass('control-showing');
                }
            }

            popupManager.showPopup(name);
        }

        // cache for tile item details
        var _cache = {};
        var _$loadingHtml = $('.overlay-wrapper .tile-content');

        /**
         * @method handleItemClick
         * Purpose Call back for the 100-ways-item click
         * @param {Object} target
         * @param (string) flag - 'nonuser' if being called by restore from url
         *
         * @author Luc Martin
         * @version 1.0
         */
        function handleItemClick(target, flag) {
            var item = $(target).data('urltitle');
            var $loading = _$loadingHtml.clone();
            if (_cache[item]) {
                preCallbackItemClick(target, flag, $loading);
                callbackItemClick(target, flag, _cache[item].clone());
                return;
            }
            preCallbackItemClick(target, flag, $loading);

            var url = '/trash/100-ways/' + item + '/';
            if (GLAD_GLOBAL.language && GLAD_GLOBAL.language !== 'en') {
                url = '/' + GLAD_GLOBAL.language + url;
            }
            $.ajax({
                url: url,
                data: {
                    ajax: 1,
                    mobile: GLAD_GLOBAL.useMobileUI(),
                },
                dataType: 'html',
            }).done(function (data) {
                var $data = $(data);

                // stamp now so uids are stored in cache
                //hundredWaysManager.stampGameItem($data);
                _cache[item] = $data;

                callbackItemClick(target, flag, _cache[item].clone());
            });
            if (typeof post_init === 'function') post_init();
        }

        function preCallbackItemClick(target, flag, detailContent) {
            // test for non user tag
            nonuser = typeof nonuser == 'undefined' && typeof flag !== 'undefined' && flag == 'nonuser' ? true : false;
            //console.info('NON USER HAS BEEN SET TO '+nonuser);

            var dataTarget = $(target).data();
            var urlTitle = dataTarget['urltitle'];
            //console.info('urlTitle: '+urlTitle);

            // modal test
            if (GLAD_GLOBAL.useMobileUI()) {
                handleCloseButtonClick();
                var parent = $('#dlg').html(detailContent);
                var $detailRow = parent;
                //$('.modal',parent).modal('show');

                popupManager.showPopup($('.modal', parent));
            } else {
                var $insertAfter = $(target);
                if ($insertAfter.data('number') % 2 === 0) {
                    var $temp = $insertAfter.next();
                    if ($temp.length) {
                        $insertAfter = $temp;
                    }
                }

                // contract the row if it's already expanded'
                var $openDetail = $('.item-detail');
                if ($openDetail.attr('data-urltitle') && $openDetail.attr('data-urltitle') == urlTitle) {
                    // except not for nonuser case - it should keep it open
                    if (flag === 'nonuser') {
                        return false;
                    }
                    //$(detailRow).animate({'height':'0px'},500).removeClass('expanded').attr('data-u',null).html('');
                    handleCloseButtonClick();
                    return false;
                } else {
                    // close any open items
                    handleCloseButtonClick();
                }

                var $detailRow = $('<div class="row item-detail"></div>');
                $insertAfter.after($detailRow);

                // stuff the expandable row with the content
                $detailRow.height(0);
                $detailRow.html(detailContent);

                // non-modal case: remove modal classes
                $('.modal', $detailRow).removeClass('modal').removeClass('fade');
                $('.modal-dialog', $detailRow).removeClass('modal-dialog');
                $('.modal-content', $detailRow).removeClass('modal-content');

                var parent = $detailRow;

                //eye candy
                $detailRow
                    .animate(
                        {
                            height: 2500,
                        },
                        1000,
                        function () {
                            $detailRow.height('auto');
                            var scroll = $detailRow.find('.tile-content').position().top - 30;
                            $('html,body').animate(
                                {
                                    scrollTop: scroll,
                                },
                                500,
                                function () {
                                    //var top = $win.scrollTop();
                                    //$('.modal-fixed.popup-showing').css('top', Number(top - 65)+'px');
                                }
                            );
                        }
                    )
                    .addClass('expanded');
            }

            $('.title-mobile', $detailRow).html(dataTarget['tiletitle']);
            $('.hidden-row-content', $detailRow).addClass(dataTarget['tileclass']);
            $('.modal-content', $detailRow).css('background-color', dataTarget['tilecolor']);
        }

        function callbackItemClick(target, flag, detailContent) {
            // test for non user tag
            nonuser = typeof nonuser == 'undefined' && typeof flag !== 'undefined' && flag == 'nonuser' ? true : false;
            //console.log('NON USER HAS BEEN SET TO '+nonuser);

            var urlTitle = $(target).first().attr('data-urltitle');

            if (GLAD_GLOBAL.useMobileUI()) {
                var parent = $('#dlg');
                var $detailRow = parent;
            } else {
                var $detailRow = $('.item-detail');
                var parent = $detailRow;
            }

            $detailRow.find('.content-loading').after(detailContent).remove();
            $detailRow.attr('data-urltitle', urlTitle);

            // TODO: encapsulate below details init into func
            // is there as slide show (cycle-2)
            var slideShow =
                $(parent).children().find('.carousel').first().length > 0
                    ? $(parent).children().find('.carousel').first()
                    : 'no Slide Show';

            // Is it a youtube?
            var videoYoutube =
                $(parent).children().find('.hundred-ways-youtube-item-content').first().length > 0
                    ? $(parent).children().find('.hundred-ways-youtube-item-content').first()
                    : 'no youtube';

            // Is it a quiz?
            var quiz =
                $(parent).children().find('.hundred-ways-quiz-with-result-item-content').first().length > 0
                    ? $(parent).children().find('.hundred-ways-quiz-with-result-item-content').first()
                    : 'no quiz';
            if (quiz === 'no quiz') {
                // check for quiz-no-tip
                var $temp = $(parent).children().find('.hundred-ways-quiz-with-result-no-tip-item-content').first();
                if ($temp.length) {
                    quiz = $temp;
                }
            }

            // loved icon
            var data = $(target).data();
            var urltitle = data['urltitle'];
            if ($.inArray(urltitle, hundredWaysManagerBrain.loved) !== -1) {
                $('.love-' + urltitle)
                    .addClass('loved')
                    .removeClass('game-action');
            }
            // post_init();

            // event for url updates
            if (flag !== 'nonuser') {
                $doc.trigger('item.open', [urltitle, data['metatitle']]);
            } else {
                $doc.trigger('item.open.nonuser', [urltitle, data['metatitle']]);
            }

            // initialize cycle if necessary
            if (slideShow !== 'no Slide Show') {
                //console.log('Initialize the slide show '+slideShow);
                var $slideshow = $detailRow.find('div.carousel').first(); // .attr('id','actualSlideShow');
                privateInitSlideShow($slideshow, flag);
            }

            // handle you tube if required
            if (videoYoutube !== 'no youtube') {
                // finds the trigger class
                var youtubeTrigger = $detailRow.children().find('.video');

                // the video id is in the html tag
                var playerId = $(youtubeTrigger).attr('data-videoplayerid');

                // Finds the player div
                $('#videoPlayer', $detailRow).attr('id', playerId);
                //post_init();
                // initialize the video
                //console.log('playerId '+playerId )
                privateInitVideo($detailRow, { videoPlayerId: playerId });
            }

            // handle the quiz
            if (quiz !== 'no quiz') {
                quizManager.processQuizSolveList(quiz);
            }
        }

        /**
         * @method handleWindowScroll
         * Purpose Call back for the window scrolling
         * @param {Object} target
         *
         * @author Luc Martin
         * @version 1.0
         */
        function handleWindowScroll(target) {
            // the scroll position
            pos = $(target).scrollTop();
            //console.log('POSITION :: ',pos)
            //console.log('phase '+currentPhase+ ' position '+ pos+ 'currentPhase '+currentPhase+' totalPhases '+totalPhases+' moreQuestions '+moreQuestions)
            // 340 is the height where the keep narrowing needs to start showing

            // window is at the top
            if (pos < 380) {
                $('.red-bar').removeClass('fixed');
                $('.sticky-logo').addClass('hidden');
            } else {
                $('.red-bar').not('.fixed').addClass('fixed');
                $('.sticky-logo').removeClass('hidden');
            }
        }

        /**
         * @method privateInitVideo(args)
         * To setup the youtube API
         *
         * @params $details details row, args Object
         * @author Luc Martin
         */
        function privateInitVideo($detail, args) {
            return;
            // Just exit. Videos are no longer on youtube and the library for displaying them will not work with webpack because of a syntax error.
            // Leaving the function here in case we want to add youtube js api call here or something.
        }

        /**
         * @method privateInitSlideShow
         *
         * Purpose: This is the standard cycle initialization for a horizontal slide show
         * @param {Object} className
         *
         * @author Luc Martin at clorox.com
         * @version $ID
         */
        function privateInitSlideShow($slideshow) {
            //console.log('INIT SLIDE SHOW >>>>> ',$slideshow);

            // the slideshow controls
            var arrowLeft = $slideshow.parent().find('.previous');
            var arrowRight = $slideshow.parent().find('.next');

            // the pager controls
            var pager = $slideshow.attr('data-cycle-pager');

            // call back after a slide is being shown
            $slideshow.on('cycle-before', function (e, options, currSlideElement, nextSlideElement, forwardFlag) {
                //console.log('cycle-before',options);

                var width = $(currSlideElement).find('img').width();
                var parent = $(currSlideElement).closest('.carousel').parent();

                $('.carousel-controls', parent).css('width', '100%').css('left', '-4px');
                //$('.previous',parent);

                // hide next-custom button on last slide
                if (options.nextSlide === options.slides.length - 1) {
                    $('.next-custom', parent).addClass('disabled');
                } else {
                    $('.next-custom', parent).removeClass('disabled');
                }

                //console.log(nextSlideElement)
                //console.log(options)
                //console.log(forwardFlag)
                //var eventName = id.replace('#','').replace('.','');
                // propagate the event to the all page
                //$body.trigger('cycle-after_'+eventName, forwardFlag);

                // event to inform url manager
                var $next = $(nextSlideElement);
                $doc.trigger('slide.change', [$next.data('slide-id'), $next]);

                // local function for the call back
            });

            // handle sending init slide id
            $slideshow.on('cycle-post-initialize', function (e, opts) {
                // inform url mgr
                var $slide = $(opts.slides[opts.currSlide]);
                $doc.trigger('slide.change', [$slide.data('slide-id'), $slide, 'initialize']);
            });

            // handle goto slide based on url state change
            $doc.on('slide.goto', function (e, slideId) {
                //console.log('slide.goto '+slideId);

                var index = 0;
                $.each($slideshow.data('cycle.opts').slides, function (i, slide) {
                    if ($(slide).data('slide-id') === slideId) {
                        index = i;
                        return false;
                    }
                });
                $slideshow.cycle('goto', index);
            });

            // Init the slideshow
            $slideshow.cycle({
                timeout: 0,
                slides: '> .slide',
                prev: arrowLeft,
                next: arrowRight,
                fx: 'scrollHorz',
                cleartypeNoBg: true,
                pager: pager,
                pagerActiveClass: 'activeSlide',
                autoHeight: 'calc',
                allowWrap: false,
            });
        }

        /**
         * public functions for the hundredWaysManager
         *
         * @author Luc Martin at Clorox
         * @version 1.0
         */
        return {
            initSlideShow: privateInitSlideShow,
            initFirstState: function () {
                privateInitFirstState();
            },
            initListeners: function () {
                privateInitListeners();
            },
            setNonuser: function (args) {
                if (typeof nonuser == 'undefined') {
                    nonuser = args;
                }
            },
            getNonuser: function () {
                return nonuser;
            },
        };
    })();

    /**
     * @module popupManager
     * Purpose: handle popups and priorities when trying to show multiple
     *
     * @author Richard d @ GPDigital
     * @version 1.0
     */
    var popupManager = (function () {
        // called on modal hide event
        function onHide() {
            // check for saved popup & restore
            if (_next) {
                var temp = _next;
                _next = null;
                setTimeout(function () {
                    privateShowPopup(temp);
                }, 150);
            }
        }

        var _next = null;
        function privateShowPopup(popup) {
            //console.assert(popup, 'trying to open null popup');

            // check for visible popup
            var $current = $('.modal.in');
            if ($current.length) {
                // is it a reopen of same popup
                if ($current[0] === $(popup)[0]) {
                    return;
                }

                //console.assert(!_next, 'trying to open 3rd popup is bad');

                if (!$current.hasClass('tile-content')) {
                    // save new one
                    _next = popup;
                    return;
                } else {
                    // current is lower priority
                    $current.modal('hide');
                    _next = $current;
                    // fall thru and show new popup
                }
            }

            var $popup = $(popup).modal('show').on('hidden.bs.modal', onHide);

            // set focus to 1st input
            setTimeout(function () {
                $popup.find('input:visible:first').focus();
            }, 250);
        }

        function privateHidePopup(popup) {
            $(popup).modal('hide');
        }

        /**
         * public functions
         *
         * @author Richard d @ GPDigital
         */
        return {
            showPopup: privateShowPopup,
            hidePopup: privateHidePopup,
        };
    })();

    /**
     * @module urlManager
     * Purpose: URL path management & restore
     *
     * @author Richard d @ GPDigital
     * @version 1.0
     */
    var urlManager = (function () {
        // flag to use when pushing history state
        //  prevent looping callbacks
        var _pushing = false;

        /**
         * @method privateUpdateUrl
         *
         * Purpose: update url history as openItem changes
         *
         * @author Richard d @ GPDigital
         */
        function privateUpdateUrl(openItem, title) {
            //console.log('privateUpdateUrl: '+openItem);
            var url = '/trash/100-ways/';
            if (GLAD_GLOBAL.language && GLAD_GLOBAL.language !== 'en') {
                url = '/' + GLAD_GLOBAL.language + url;
            }
            if (openItem) {
                url += openItem + '/';
            } else {
                title = '100 Ways | Glad';
            }
            _pushing = true;
            History.pushState('', title, url);
            _pushing = false;
        }

        /**
         * @method privateUpdateUrlSlide
         *
         * Purpose: update url history as slide on open item changes
         *
         * @author Richard d @ GPDigital
         */
        function privateUpdateUrlSlide(slide) {
            //console.log('privateUpdateUrlSlide: '+slide);
            var parts = location.pathname.split('/');

            var indexPart = 4;
            if (GLAD_GLOBAL.language && GLAD_GLOBAL.language !== 'en') {
                indexPart++;
            }
            if (parts[indexPart] === slide) {
                //console.log('already on slide '+slide);
                return;
            }
            var newparts = [parts[1], parts[2], parts[3], slide];
            var url = '/' + newparts.join('/') + '/';
            if (GLAD_GLOBAL.language && GLAD_GLOBAL.language !== 'en') {
                url = '/' + GLAD_GLOBAL.language + url;
            }
            _pushing = true;
            History.pushState('', History.getState().title, url);
            _pushing = false;
        }

        /**
         * @method privateStateChange
         *
         * Purpose: handles change in state based on url
         *    will load page & open/close item as needed
         *
         * @author Richard d @ GPDigital
         */
        function privateStateChange() {
            var state = History.getState();

            // state change from pushstate call?
            if (_pushing) {
                //console.log('statechange - internal, ignore');
                return;
            }

            var path = state.hash.split('?')[0]; // prevent querystr from looking like path
            //console.log('statechange received: '+path);
            var parts = path.split('/');
            var indexPart = 3;
            if (GLAD_GLOBAL.language && GLAD_GLOBAL.language !== 'en') {
                indexPart++;
            }
            var item = parts[indexPart];

            if (item) {
                //console.log('SETTING NON USER TO TRUE');
                hundredWaysManager.setNonuser(true);
                var regex = new RegExp('\\?');
                var match = item.match(regex);
                if (!match) {
                    $('.cta[data-urltitle=' + item + ']').trigger('click', ['nonuser']);
                    if (parts[4]) {
                        var slideshow = $('.carousel:visible').data('cycle.opts');
                        if (slideshow) {
                            $doc.trigger('slide.goto', [parts[4]]);
                        } else {
                            // wait for slideshow to init
                            $body.one('cycle-post-initialize', function () {
                                $doc.trigger('slide.goto', [parts[4]]);
                            });
                        }
                    }
                } else {
                    hundredWaysManager.setNonuser(false);
                }
            } else {
                hundredWaysManager.setNonuser(false);
                $('.item-detail .close-button').trigger('click', ['nonuser']);
                $('#dlg .close-button').trigger('click', ['nonuser']);
            }
        }

        /**
         * @method privateInit
         *
         * Purpose: initialize obj & event listeners
         *
         * @author Richard d @ GPDigital
         */
        function privateInit() {
            // listeners
            // panel open
            $doc.on('item.open', function (e, openItem, title) {
                privateUpdateUrl(openItem, title);
            });

            // slideshow change in slide
            $doc.on('slide.change', function (e, slide) {
                privateUpdateUrlSlide(slide);
            });

            // restore state from Url
            $win.on('statechange', privateStateChange);
            privateStateChange();
        }

        return {
            init: privateInit,
        };
    })();

    var wpmlMgr = (function () {
        // initalizer
        function _init() {
            var _baseUrl = $('.hundred-ways').data(GLAD_GLOBAL.language + '-url');
            var $toggle = $('.language-toggle');

            // add handlers
            $doc.on('item.open item.open.nonuser', function (e, openItem) {
                // wpml lang switcher support
                // update based on current panel
                // panel has data on whether translation exists
                if (openItem) {
                    var wpmlData = $('.content-main').data();
                    $toggle.data('missing', wpmlData.langMissing);
                    if (!wpmlData.langMissing) {
                        $('a', $toggle).attr('href', wpmlData.langUrl);
                    } else {
                        $('a', $toggle).attr('href', _baseUrl);
                    }
                } else {
                    // item closed
                    $toggle.data('missing', 0);
                    $('a', $toggle).attr('href', _baseUrl);
                }
            });
        }

        /**
         * public functions
         */
        return {
            init: _init,
        };
    })();

    // initialize js
    $(document).ready(function () {
        hundredWaysManager.initListeners();
        hundredWaysManager.initFirstState();

        quizManager.initListeners();
        quizManager.formatList();

        urlManager.init();

        wpmlMgr.init();

        // run tests
        //processTestMode();
    });

    // code needed for WIF page
    // TODO: move shared code to shared js file
    window.SHARED_CODE = {
        initSlideShow: hundredWaysManager.initSlideShow,
        processQuizSolveList: quizManager.processQuizSolveList,
    };
})(jQuery);
